import { getRoomData } from './GameService';

// One ordinary snapshot/presence read per mounted room. Recovery owns its own
// authority checks; this reader must not compete with it or apply late replies.
export const createRoomReader = ({ roomId, playerId, canRead, onStart, onSnapshot, onError }) => {
    let pending = null;
    let disposed = false;
    const cancel = () => { pending?.abort(); };
    const read = async () => {
        if (disposed || pending || !canRead()) return;
        const controller = new AbortController();
        pending = controller;
        onStart();
        try {
            const snapshot = await getRoomData(roomId, playerId, { timeout: 5000, signal: controller.signal });
            if (!disposed && !controller.signal.aborted && canRead()) onSnapshot(snapshot);
        } catch (error) {
            if (!disposed && !controller.signal.aborted && error?.code !== 'ERR_CANCELED') onError(error);
        } finally {
            if (pending === controller) pending = null;
        }
    };
    return { read, cancel, dispose: () => { disposed = true; cancel(); } };
};
